var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpeakLanguages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54 93H48V85.145L56.2925 81H60C61.655 81 63 79.655 63 78V70.7575L71.04 62.7175L63.4225 52.56L63.295 52.29C63.015 51.7025 63.005 51.1875 63.0025 51.0175C62.99 50.335 62.8 44.1875 60.085 38.3275C56.6 30.81 50.5175 26.9975 42.0025 26.9975C38.3425 26.9975 31.38 27.645 25.8675 31.98C20.6625 36.0725 18.0225 42.4725 18.0225 50.9975C18.0225 59.05 24.915 68.29 26.295 70.06C26.4825 70.3 27.025 70.995 27 72.0575V92.9975H21V73.0125C18.3025 69.4125 12.0225 60.0525 12.0225 50.9975C12.0225 28.8775 27.5075 20.9975 42 20.9975C52.9025 20.9975 61.0375 26.1175 65.525 35.805C68.215 41.6075 68.8225 47.495 68.96 49.945L75.8375 59.115C77.6175 61.4875 77.3775 64.86 75.28 66.9575L68.9975 73.24V77.9975C68.9975 82.96 64.96 86.9975 59.9975 86.9975H57.705L53.9975 88.8525V92.9975L54 93ZM21 71.9525C21 71.9875 21 72.0225 21 72.0575V71.9525Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M100.334 45.5035L82.3346 57.503L85.6628 62.4953L103.662 50.4958L100.334 45.5035Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M85.6626 75.5023L82.3344 80.4946L100.334 92.4942L103.662 87.5019L85.6626 75.5023Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M105 65.9976H84V71.9976H105V65.9976Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeakLanguages);
export default __webpack_public_path__ + "static/media/Speak_Languages.30450321.svg";
export { ForwardRef as ReactComponent };